/* global module, require */
const THREE = require('three'),
	makeGlass = require('./makeGlass'),
	unit = require('../unit');

const filling = unit.mm(0.76);
const material = new THREE.MeshPhongMaterial({
	color: 0xa4a8ff,
	opacity: 0.3,
	transparent: true,
	side: THREE.DoubleSide,
});

module.exports = function makeLaminatedGlass({
	between,
	gap,
	height,
	start,
	thickness,
	offset,
}) {
	const group = new THREE.Group();
	const pane = (thickness - filling) / 2;
	const dir = new THREE.Vector3()
		.copy(between)
		.normalize()
		.applyAxisAngle(new THREE.Vector3(0, 1, 0), Math.PI / 2)
		.multiplyScalar((pane + filling) / 2);

	group.add(
		makeGlass({
			between,
			gap,
			height,
			start: new THREE.Vector3().copy(start).add(dir),
			thickness: pane,
			offset,
			material,
		})
	);
	dir.multiplyScalar(-1);
	group.add(
		makeGlass({
			between,
			gap,
			height,
			start: new THREE.Vector3().copy(start).add(dir),
			thickness: pane,
			offset,
			material,
		})
	);
	return group;
};
